import { render, staticRenderFns } from "./groupStatementDetail.vue?vue&type=template&id=919e575a&"
import script from "./groupStatementDetail.vue?vue&type=script&lang=js&"
export * from "./groupStatementDetail.vue?vue&type=script&lang=js&"
import style0 from "./groupStatementDetail.vue?vue&type=style&index=0&id=919e575a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports